import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getWorkflowSettings, updateWorkflowSettings } from "../services/settingsService";

export const useWorkflowSettings = () => {
  const [settings, setSettings] = useState({
    approvalMaterialRelease: false,
    autoAssignLeads: false,
    assignAppointedLeads: false,
    enableLocationTracker: false,
    approvalProjectStart: false,
    approvalProjectCost: false,
    approvalMeterConnection: false,
    approvalFinalPayment: false,
    enableMessaging: false,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await getWorkflowSettings();
        if (res) {
          setSettings(res);
        }
      } catch (error) {
        console.error("Failed to fetch workflow settings", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const toggleSetting = async (field) => {
    const newVal = !settings[field];
    const prevSettings = { ...settings };
    
    // Optimistic update
    setSettings(prev => ({ ...prev, [field]: newVal }));
    
    setSaving(true);
    try {
      await updateWorkflowSettings({ [field]: newVal });
      toast.success("Workflow setting updated");
    } catch (error) {
      setSettings(prevSettings);
      toast.error("Failed to update setting");
    } finally {
      setSaving(false);
    }
  };

  return { settings, loading, saving, toggleSetting };
};




